<app-loading></app-loading>
<div style="min-height: 80vh">
    <app-header (themeChange)="onThemeChange($event)"></app-header>
    <app-notification-card></app-notification-card>
    <div [@routerTransition]="getTriggerState()">
        <router-outlet #o="outlet"></router-outlet>
    </div>
</div>